import {
    RECEIVE_YOUNGER_DEPENDENTS,
    REMOVE_YOUNGER_DEPENDENT,
    REQUEST_YOUNGER_DEPENDENTS,
} from '../actions/younger-dependents'
import { updateOrAddItemsById } from '../helpers'

export default (
    state = {
        fetchSuccessful: null,
        isFetching: false,
        items: [],
        shouldFetch: true,
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case REQUEST_YOUNGER_DEPENDENTS:
            return { ...state, isFetching: true, shouldFetch: false }

        case RECEIVE_YOUNGER_DEPENDENTS: {
            const { items: currentItems } = state
            const { items: receivedItems } = data

            const items = updateOrAddItemsById({ currentItems, receivedItems })

            return { ...state, isFetching: false, ...data, items }
        }

        case REMOVE_YOUNGER_DEPENDENT: {
            const { items: currentItems } = state
            const { id } = data

            const items = currentItems.filter((o) => o.id !== id)

            return {
                ...state,
                items,
            }
        }

        default:
            return state
    }
}
